import React, { Fragment, useCallback, useEffect, useState } from 'react';
import {
    Input,
    Button,
    Row,
    Col,
    Label
} from 'reactstrap';
import './Contacts2.css';
import {
    Link,
} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimes, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import ConfirmButton from '../Modal/ConfirmButton';
import Autocomplete from '../Autocomplete/Autocomplete';

const AddContact2 = (props) => {
    const {
        companies,
        notesCategories,
        userPermissions,
        setComment,
        handleAddSubmit,
        handleCancel,
        loading,
        isFormBlank,
        unsavedChanges,
        clientToken,
        onSelectAutocomplete,
        removeCompany
    } = props;

    const [addCategoryCommentsArray, setAddCategoryCommentsArray] = useState(() => notesCategories || []);
    useEffect(() => {
        setAddCategoryCommentsArray(notesCategories || []);
    }, [notesCategories]);

    const checkPermission = useCallback((permission) => {
        return (
            permission === '' ||
            permission == null ||
            (userPermissions || []).findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1
        );
    }, [userPermissions]);

    // const allLists = useMemo(() => {
    //     if (!Array.isArray(notesCategories?.data)) return [];
    //     return notesCategories.data
    //         .reduce((childArray, currentValue) => childArray.concat(currentValue.children), [])
    //         .reduce((listArray, listValue) => (listValue.list != null ? listArray.concat(listValue.list) : listArray), []);
    // }, [notesCategories]);

    const onCancel = useCallback(() => {
        handleCancel && handleCancel();
    }, [handleCancel]);

    const onAdd = useCallback(() => {
        handleAddSubmit && handleAddSubmit();
    }, [handleAddSubmit]);

    return (
        <Row>
            <Col md={4} className='text-left'>
                <Label>Companies</Label>
                <Autocomplete
                    clientToken={clientToken}
                    newPage={false}
                    onSelect={onSelectAutocomplete}
                    enableHistory={true}
                    clearOnSelect={true}
                    placeholder="Search to Add Company"
                    showContacts={false}
                />

                {companies?.map((company, companyIndex) => (
                    <Row key={company.secID + '_' + companyIndex} className='border-top border-light py-2 my-2'>
                        <Col md={9} className='text-center'>
                            <Link
                                to={{ pathname: `/demographics/${company.secID}`, state: {} }}
                                style={{ marginRight: '8px' }}
                            >
                                <div>{company.primaryBusinessName}</div>
                                <Label>{company.secID}</Label>
                            </Link>
                        </Col>
                        <Col className='text-right'>
                            <ConfirmButton
                                color="danger"
                                onClick={() => removeCompany(company.secID)}
                                title="Delete"
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </ConfirmButton>
                        </Col>
                    </Row>
                ))}
            </Col>

            <Col className="pl-5">
                <Row>
                    <Col md={8} className="text-left pl-3">
                        {addCategoryCommentsArray.map(row => {
                            if (row.validation === 'list' && row.multiline) {
                                return (
                                    <Fragment key={row.ID}>
                                        <Row className="mb-2 mx-0">
                                            <Label>{row.type}</Label>
                                            <Input
                                                type="select"
                                                name={row.ID}
                                                multiple
                                                onChange={setComment}
                                                value={Array.isArray(row.value) ? row.value : []}
                                            >
                                                <option value="0">Select {row.type}</option>
                                                {row.list != null && row.list.map(item => (
                                                    <option key={item.ID} value={String(item.ID)}>
                                                        {item.longDescription}
                                                    </option>
                                                ))}
                                            </Input>
                                        </Row>
                                    </Fragment>
                                );
                            }

                            switch (row.validation) {
                                case "list": {
                                    // const showOther =
                                    //     allLists.findIndex(
                                    //         item => item.ID === parseInt(row.value) && item.longDescription === 'Other'
                                    //     ) > -1;

                                    return (
                                        <Fragment key={row.ID}>
                                            <Row className="mb-2 mx-0">
                                                <Label>{row.type}</Label>
                                                <Input
                                                    type="select"
                                                    name={row.ID}
                                                    onChange={setComment}
                                                    value={row.value}
                                                >
                                                    <option value="0">Select {row.type}</option>
                                                    {row.list != null && row.list
                                                        .filter(item => item.longDescription !== 'Other' || (checkPermission('Create Other List Item') && item.longDescription === 'Other'))
                                                        .map(item => (
                                                            <option key={item.ID} value={item.ID}>
                                                                {item.longDescription}
                                                            </option>
                                                        ))}
                                                </Input>
                                            </Row>
                                        </Fragment>
                                    );
                                }

                                case "date": {
                                    const value = row.value == null ? '' : row.value;
                                    return (
                                        <Row key={row.ID} className="mb-2 mx-0">
                                            <Label>{row.type}</Label>
                                            <Input
                                                name={row.ID}
                                                onChange={setComment}
                                                type="date"
                                                value={value}
                                            />
                                        </Row>
                                    );
                                }

                                case "checkbox":
                                    return (
                                        <Row key={row.ID} className="mb-2 pl-4 mx-0">
                                            <Input
                                                name={row.ID}
                                                onChange={setComment}
                                                type="checkbox"
                                            />
                                            {row.type}
                                        </Row>
                                    );

                                case null:
                                    return (
                                        <Row key={row.ID} className="mb-2 mx-0">
                                            <Label>{row.type}</Label>
                                            <Input
                                                name={row.ID}
                                                onChange={setComment}
                                                type={row.multiline ? 'textarea' : 'text'}
                                            />
                                        </Row>
                                    );

                                default:
                                    return (
                                        <Row key={row.ID} className="mb-2 mx-0">
                                            <Label>
                                                {row.type}{' '}
                                                {row.validationHint != null ? (
                                                    <span className="validationHint">({row.validationHint})</span>
                                                ) : null}
                                            </Label>
                                            <Input
                                                className={row.error ? "is-invalid" : ''}
                                                name={row.ID}
                                                onChange={(e) => setComment(e, row.validation)}
                                                type={row.multiline ? 'textarea' : 'text'}
                                            />
                                        </Row>
                                    );
                            }
                        })}
                    </Col>

                    <Col sm={4} className="text-right notesFormTypeControls">
                        <Button
                            title="Add Contact"
                            key="buttonAdd"
                            color="success"
                            onClick={onAdd}
                            disabled={
                                addCategoryCommentsArray.length === 0 &&
                                (loading ||
                                    isFormBlank(addCategoryCommentsArray) ||
                                    addCategoryCommentsArray.filter(item => item.error).length > 0)
                            }
                        >
                            <FontAwesomeIcon icon={loading ? faSpinner : faPlus} title="Add Contact" />
                        </Button>

                        {unsavedChanges ? (
                            <ConfirmButton
                                color="secondary"
                                onClick={onCancel}
                                title="Cancel"
                                body="Are you sure you wish to discard adding this contact?"
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </ConfirmButton>
                        ) : (
                            <Button
                                key="buttonCancel"
                                color="secondary"
                                onClick={onCancel}
                                title="Cancel"
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </Button>
                        )}
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default AddContact2;